import React from 'react'
import styles from './CardTable.module.scss'
import cx from 'classnames'

type CardTableCellProps = {
  children?: React.ReactNode
  width?: string
  className?: string
}

export const CardTableCell = ({
  children,
  width = 'auto',
  className,
}: CardTableCellProps) => (
  <td
    className={cx(styles.cardTableCell, className)}
    style={{ [`--width`]: width }}
  >
    {children}
  </td>
)
